module.exports = __webpack_public_path__ + "static/media/leading-icon.e52c6647.svg";